import type React from 'react'

import { SpriteMap, SpriteMap16 } from '../global'
import { createVariants } from '../lib'
import { Icon } from './Icon'

export enum StatusChipColor {
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger'
}

const statusChipClasses = createVariants({
  base: 'flex rounded-lg h-6 px-2 gap-x-2 items-center',
  variants: {
    color: {
      success: 'bg-clover-100',
      warning: 'bg-marigold-100',
      danger: 'bg-ruby-200'
    }
  }
})

const statusChipIconClasses = createVariants({
  base: 'size-4',
  variants: {
    color: {
      success: 'text-clover-500',
      warning: '',
      danger: ''
    }
  }
})

export const StatusChip: React.FC<{ text: string; color: StatusChipColor }> = ({ text, color }) => (
  <div className={statusChipClasses({ color })}>
    {text}
    <Icon
      icon={color === StatusChipColor.Success ? SpriteMap16.CheckCircle16 : SpriteMap.InfoIcon}
      className={statusChipIconClasses({ color })}
    />
  </div>
)
